module.exports = __webpack_public_path__ + "static/media/Autorizacion_Data.c9e553b4.pdf";